import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomerStyle from "../../../../utils/customerStyle";
import BaseUrl from "../../../../utils/BaseUrl";
import { UserContext } from "../../../../utils/User_check";
import ContentSection from "../../../Content";

const url = BaseUrl();
const customerStyle = CustomerStyle();
function AssetDeployePage(){

    const [loading,setLoading] = useState(false);
    const [ArticleList,setArticleList] = useState([]);
    const [itemsListFilter,setItemsListFilter] = useState([]);
    const [ref,setRef] = useState([]);
    const [materiel,setMateriel] = useState([]);
    const [item,setItem] = useState(null);
    const [motif_declassement,setMotifDeclassement] = useState('');
        const {user,permissions} = useContext(UserContext);
    const navigate = useNavigate();  

    const [isLoadingPdf,setIsLoadingPdf] = useState(false);
    

    const columns = [
        {
            name: 'QR CODE',
            selector: row => (
                <>
                    <img className="p-1" src={`${url.image}/${row?.qrcode_path}`}  width={100}/>
                </>
            ),
            sortable: true,
        },
        {
            name: 'REF. DEMANDE',
            selector: row =>row?.demande?.reference,
            sortable: true,
        },
        {
            name: 'TERRITOIRE',
            selector: row =>row?.demande?.d_territoire,
            sortable: true,
        },
         {
            name: 'PDV',
            selector: row =>row?.demande?.d_pdv,
            sortable: true,
        },

        {
          name: 'CATEGORIE',
          selector: row => row.materiel?.categorie?.libelle,
          sortable: true,
        },


        {
            name: 'MARQUE',
            selector: row => row.materiel?.marque?.libelle ,
            sortable: true,
        },

        //   {
        //     name: 'ADRESSE ACTUELLE',
        //     selector: row => (
        //         <>
        //             {row?.position_materiel?.length > 0 &&
        //                 <>
        //                     {row?.position_materiel[0]?.depot_id !== null && <b>{row?.position_materiel[0]?.depot?.name}</b>}
        //                     {row?.position_materiel[0]?.pointdevente_id !==	null && <b>{row?.position_materiel[0]?.d_pdv}</b>}
        //                 </>
        //             }
        //         </>
        //     ),
        //     sortable: true,
        //   },
    
        {
          name: "Statut",
          selector : row => (
            <>
            {row.status == 1 && <span class="badge bg-warning">En attente d'affectation</span>}
            {row.status == 2 && <span class="badge bg-success">Deployé</span>}
            {row.status == 3 && <span class="badge bg-danger">Declassé</span>}
            {row.status == 4 && <span class="badge bg-warning">A deployer</span>}
            {row.status == 0 && <span class="badge bg-warning">En stock</span>}
            </>
          )
        },
        {
            name: "Action",
            selector : row => (
                <>
                {ref === row.reference && loading ? 
                <div class="text-center">
                    <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
                
                : 
                    <>
                        <button className="btn btn-success btn-sm mx-1" onClick={()=>openViewModal(row)}> <i class="fa-solid fa-eye"></i> </button>
                         <button className="btn btn-dark btn-sm mx-1" onClick={()=>getListPdfSingleDownload(row.num_serie)}> <i class="fa-solid fa-qrcode"></i> </button>
                    </>
                }

                </>
            )
          },

    ];
        useEffect(()=>{
        // if(!can(permissions,'detail-stock')){
        //     navigate('/tableau-de-bord');
        // }
    },[user,permissions]);
    
    useEffect(()=>{
        fetchTransfertList();
    },[]);

    const fetchTransfertList = async ()=>{
        setLoading(true);
        try {
            axios.get(url.base+'/get-asset-deploye',{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
                setLoading(false);
                setArticleList(resp.data.data);
                setItemsListFilter(resp.data.data);  
            })
        } catch (error) {
            setLoading(false);
        }
    }

    const handleFilter=(event)=>{
        const datas = itemsListFilter.filter(row => row.num_serie.toLowerCase().includes(event.target.value.toLowerCase()));
        setArticleList(datas);
    }

    const openDeclassementModal=(row)=>{
        setItem(row);
        window.$('#exampleModal-2').modal('show');
    }

    const openViewModal=(row)=>{
        setItem(row);
        window.$('#basicModal').modal('show');
    }




    const DownloadFile= (reference)=>{
        // e.preventDefault();    
      
        try {
            axios.get(url.base+'/download-file-import-materiel/'+reference,
            {
                headers:{
                    'Content-Type':'application/pdf',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`,
                    
                },
                responseType:'blob',
                // credentials:'include'
            }
            ).then((response)=>{
                // setSubLoading(false);
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'materiel_import.xlsx');
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }).catch((error)=>{
                // setSubLoading(false);
                console.log(error);
            })
        } catch (error) {
            // setSubLoading(false);
            console.log(error);  
        }
    }




function getListPdfSingleDownload(numSerie) {
        setIsLoadingPdf(true);
        try {
            axios.get(`${url.base}/materiel-pdf-qrcode-single/${numSerie}`, {
            headers: {
                "Authorization": `Bearer ${localStorage.getItem('_token_')}`
            },
            responseType: 'blob' // <-- c’est ESSENTIEL
            }).then((resp) => {
            setIsLoadingPdf(false);
            if (resp.status === 200) {
                const blob = new Blob([resp.data], { type: 'application/pdf' });
                const urlBlob = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = urlBlob;
                link.setAttribute('download', 'asset_qrcode_materiel.pdf');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
            }).catch((error) => {
            console.error(error);
            setIsLoadingPdf(false);
            });
        } catch (error) {
            console.error(error);
            setIsLoadingPdf(false);
        }
}


    return (
        <>
            <ContentSection ulShownav={"gest-affectations"} navactive={"stock-deployes"}>
                <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-12">
                                
                                <div class="mb-5">
                                    <h3 class="mb-0 text-primary">
                                            Liste des assets deployés
                                    </h3>

                                </div>
                            </div>
                        </div>
                        <div>                            
                            <div class="row">
                                <div class="col-12">
                                    
                                    <div class="card mb-4">
                                        <div class="card-header  ">
                                            <div class="row">
                                                <div class=" col-lg-3 col-md-6">
                                                    <input type="search" class="form-control " placeholder="Numéro de serie..." onChange={handleFilter} />

                                                </div>
                                                <div class="col-lg-4 col-md-6 d-flex align-items-center mt-3 mt-md-0">

                                                </div>

                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <div class="table-responsive">
                                                <DataTable 
                                                    columns={columns} 
                                                    data={ArticleList}
                                                    customStyles={customerStyle}
                                                    pagination
                                                    selectableRows
                                                    progressPending={loading}
                                                    progressComponent={
                                                        <>
                                                        <div class="text-center">
                                                            <div class="spinner-border" role="status">
                                                            <span class="visually-hidden">Loading...</span>
                                                            </div>
                                                        </div>
                                                        </>
                                                    } 
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                </div>



            <div class="modal fade" id="basicModal" tabindex="-1"  aria-hidden="true">
                        <div class="modal-dialog modal-xl">
                        <div class="modal-content">
                            <div class="modal-header">
                            <h5 class="modal-title">Information complète</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                            <table class="table table-striped">
                             
                                <tbody>
                                <tr>
                                    <td><b>NUMERO DE SERIE</b></td>
                                    <td></td>
                                    <td></td>
                                    <td>{item?.num_serie}</td>
                                </tr>
                                <tr>
                                    <td><b>CATERGORIE</b></td>
                                    <td></td>
                                    <td></td>
                                    <td>{item?.materiel?.categorie?.libelle}</td>
                                </tr>  
                                <tr>
                                    <td><b>MARQUE</b></td>
                                    <td></td>
                                    <td></td>
                                    <td>{item?.materiel?.marque?.libelle}</td>
                                </tr>     
                                <tr>
                                    <td><b>MODELE</b></td>
                                    <td></td>
                                    <td></td>
                                    <td>{item?.materiel?.modele?.libelle}</td>
                                </tr>                                
                                <tr>
                                    <td><b>DATE D'ACQUISITION</b></td>
                                    <td></td>
                                    <td></td>
                                    <td>{moment(item?.date_acquisition).format("Do MMMM YYYY")}</td>
                                </tr>   
                                <tr>
                                    <td><b>STATUT</b></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                    {item?.status === 1 && <span class="badge bg-warning">EN ATTENTE AFFECTATION</span>}
                                    {item?.status === 2 && <span class="badge bg-success">DEPLOYE</span>}
                                    {item?.status === 3 && <span class="badge bg-danger">DECLASSE</span>}
                                    {item?.status === 4 && <span class="badge bg-danger">A DEPLOYER</span>}
                                    {item?.status === 0 && <span class="badge bg-success">EN STOCK</span>}
                                    </td>
                                </tr>   
                                  
                                <tr>
                                    <td><b>QR CODE</b></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                    <img className="p-1" src={`${url.image}/${item?.qrcode_path}`}  width={100}/>
                                    </td>
                                </tr>     
                                <tr>
                                    <td><b>CAPACITE</b></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <b>{item?.materiel?.capacite?.libelle}</b>
                                    </td>
                                </tr>     
                                {/* <tr>
                                    <td><b>ADRESSE ACTUELLE</b></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        {item?.position_materiel[0]?.depot_id !== null && <b>{item?.position_materiel[0]?.depot?.name}</b>}
                                        {item?.position_materiel[0]?.pointdevente_id !==	null && <b>{item?.position_materiel[0]?.d_pdv}</b>}
                                    </td>
                                </tr>     */}
                                <tr className="bg-danger-soft">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>  
                                <tr>
                                    <td><b>PDV</b></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                    {item?.demande?.d_pdv}
                                    </td>
                                </tr>     
                                <tr>
                                    <td><b>CONTACT PDV</b></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <b>
                                            {item?.demande?.contact}
                                        </b>
                                    </td>
                                </tr>     
                              
                               
      
                                </tbody>
                            </table>
                            </div>
                           
                        </div>
                        </div>
            </div>
            </ContentSection>
        </>
    )
}

export default AssetDeployePage;